// extracted by mini-css-extract-plugin
export default {"removeIcon":"SelectedAssetGroupsTable_removeIcon__yaM-x"};